import walletApi from './wallet';

export const getPortfolioSummary = (currency = 'BRL') =>
  walletApi.get(`/portfolio/summary?currency=${currency}`);

export const postPortfolioDeposit = (body) =>
  walletApi.post('/portfolio/deposits', body);

export const postPortfolioWithdrawal = (body) =>
  walletApi.post('/portfolio/withdrawals', body);

export const getPortfolioRealizations = (params) =>
  walletApi.get('/portfolio/realizations', { params });
